import type { RouteRecordRaw } from 'vue-router'
import { ScheduledRoutes } from '@/routes/user/scheduled/types'
import { AppModule } from '@/config/types'

export const scheduledPausedRoutes: RouteRecordRaw = {
  name: ScheduledRoutes.paused,
  path: 'paused',
  redirect: { name: ScheduledRoutes.pausedOverview },
  component: () => import('@/components/views/scheduled/ScheduledPaused.vue'),
  children: [
    {
      name: ScheduledRoutes.pausedOverview,
      path: '',
      meta: {
        tags: ['SCHEDULED_BAR_LIST'],
        tabTitle: 'pageTabTitle.user.scheduled.paused',
        modules: [AppModule.ScheduledPaused],
      },
      component: () => import('@/components/views/scheduled/ScheduledPausedSms.vue'),
    },
    {
      name: ScheduledRoutes.pausedOverviewEmail,
      path: 'email',
      meta: {
        tabTitle: 'pageTabTitle.user.scheduled.pausedEmail',
        modules: [AppModule.ScheduledEmail, AppModule.Recipient, AppModule.CampaignsSenders],
      },
      component: () => import('@/components/views/scheduled/ScheduledPausedEmail.vue'),
    },
  ],
}
